<template>
  <v-dialog v-model="open" max-width="900px" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon="mdi-clock-outline"
          icon-action="mdi-pencil-outline"
          title="Horários"
          v-bind="attrs"
          v-on="on"
      >
        <template slot:subtitle>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="(time, index) in resumeItems" :key="index">
                  <td :class="{'td-day': time.label !== ''}">{{ time.label }}</td>
                  <td>{{ getResumeItemLabel(time) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </location-info-item>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Horários
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
            @submit="e => e.preventDefault()"
        >
          <location-schedule-list
              v-bind:value="formData.regular_hours"
              v-on:change="updateData"
              :limit="3"
              add-text="Adicionar horário"
          />

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex'
import {TYPE_UPDATE_LOCATION_REGULAR_HOUR} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'
import LocationScheduleList from '@/views/Locations/Components/LocationScheduleList'
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import {get} from 'lodash'

export default {
  name: "LocationScheduleModal",
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean
    },
    alertScheduleTask: Array,
  },
  computed: {
    ...mapState({
      location: state => state.locations.location
    }),
    days() {
      return {
        MONDAY: 'Segunda-feira',
        TUESDAY: 'Terça-feira',
        WEDNESDAY: 'Quarta-feira',
        THURSDAY: 'Quinta-feira',
        FRIDAY: 'Sexta-feira',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo'
      }
    }
  },
  components: {
    LocationInfoItem,
    ScheduleForm,
    LocationScheduleList
  },
  beforeDestroy() {
    this.resetData()
  },
  data: () => ({
    resumeItems: [],
    open: false,
    loading: false,
    formValid: true,
    value: {},
    formDataOriginal: {},
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_REGULAR_HOUR,
      regular_hours: {},
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
    },
    alertScheduledTask: null,
  }),
  mounted() {
    if (this.location && !this.bulkUpdate) {
      this.formData.regular_hours = get(this.location, 'data.regularHours', {})
      this.formDataOriginal.regular_hours = get(this.location, 'data.regularHours', {})
    }

    this.getResumeInfo()

    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_REGULAR_HOUR) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  methods: {
    cancel() {
      this.open = false
      this.resetData()
    },
    resetData() {
      const {regular_hours} = this.formDataOriginal
      this.formData.regular_hours = regular_hours || {}
      this.value = {}
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'regular_hours')
      }
    },
    callAction: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let data = { ...this.formData }
        let regularHours = []

        for (const day in this.formData.regular_hours) {
          const items = this.formData.regular_hours[day] && this.formData.regular_hours[day] || []
          items.forEach(item => {
            if (item.open_time && item.close_time) {
              regularHours.push({
                open_time: item.open_time,
                close_time: item.close_time,
                open_day: item.open_day || day,
                close_day: item.close_day  || day,
                is_24_hours: false
              })
            } else if (item.is_24_hours) {
              regularHours.push({
                open_time: '',
                close_time: '',
                open_day: item.open_day || day,
                close_day: item.close_day  || day,
                is_24_hours: true
              })
            }
          })
        }
        data.regular_hours = regularHours
        if (this.bulkUpdate) {
          this.$emit('savePayload', 'regular_hours', data.regular_hours);
        } if (this.action) {
          await this.action(data)
        }
        this.open = false
        this.loading = false
      }
    },
    changeScheduleDate(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    },
    updateData(values) {
      this.formData.regular_hours = values
      this.getResumeInfo()
    },
    getResumeInfo() {
      let items = []
      for (const day in this.days) {
        if (this.formData && this.formData.regular_hours && this.formData.regular_hours[day]) {
          let timeIndex = 0
          for (const time of this.formData.regular_hours[day]) {
            const label = timeIndex === 0 ? this.days[day] : ''
            items.push({ label, ...time })
            timeIndex++
          }
        } else {
          items.push({ label: this.days[day], open: false })
        }
      }
      this.resumeItems = items
    },
    getResumeItemLabel(time) {
      if (time.is_24_hours) {
        return '24 horas'
      }
      if (!time.open) {
        return 'Fechado'
      }
      return `${time.open_time} - ${time.close_time}`
    }
  },
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.formData.regular_hours = get(location, 'data.regularHours', {})
        this.formDataOriginal.regular_hours = get(location, 'data.regularHours', {})
      }
      this.getResumeInfo()
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.formData.regular_hours = get(this.location, 'data.regularHours', {})
        this.formDataOriginal.regular_hours = get(this.location, 'data.regularHours', {})
      }
      this.getResumeInfo()
    }
  }
}
</script>

<style scoped>
::v-deep td {
  border: none !important;
  padding-left: 0 !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

::v-deep td.td-day {
  width: 110px;
}

::v-deep tr:hover {
  background-color: transparent !important;
}
</style>